import { cn } from "@/lib/cn";
import type { IconeComCor } from "./icones-da-selecao";

/** Ícone colorido num quadrado de fundo claro — o mesmo desenho do Menu. */
const CAIXA = { sm: "h-6 w-6", md: "h-8 w-8", lg: "h-11 w-11 rounded-xl", xl: "h-14 w-14 rounded-xl" };
const ICONE = { sm: "h-3.5 w-3.5", md: "h-4 w-4", lg: "h-5 w-5", xl: "h-8 w-8" };
// O desenho próprio tem mais detalhe que o lucide, então ocupa mais da caixa.
const IMAGEM = { sm: "h-[18px] w-[18px]", md: "h-6 w-6", lg: "h-8 w-8", xl: "h-11 w-11" };

export function IconeColorido({ icone: Icone, cor, imagem, tamanho = "md" }: IconeComCor & { tamanho?: keyof typeof CAIXA }) {
  return (
    <span
      aria-hidden="true"
      className={cn("flex shrink-0 items-center justify-center rounded-lg", CAIXA[tamanho])}
      style={{ backgroundColor: `${cor}1a`, color: cor }}
    >
      {imagem ? (
        <span
          className={IMAGEM[tamanho]}
          style={{ backgroundColor: cor, mask: `url("${imagem}") center / contain no-repeat`, WebkitMask: `url("${imagem}") center / contain no-repeat` }}
        />
      ) : (
        <Icone className={ICONE[tamanho]} />
      )}
    </span>
  );
}
